import React from 'react';
import { Link } from 'react-router-dom';
import SeoHead from '@/components/layout/SeoHead';
import { Home, ArrowLeft } from 'lucide-react';

export default function NotFound() {
  return (
    <>
      <SeoHead
        title="Page Not Found | Ohana Property Services"
        description="The page you're looking for doesn't exist. Head back home and we'll get you where you need to go."
      />
      <section className="bg-ohana-bg" data-testid="not-found-page">
        <div className="container-ohana flex flex-col items-center justify-center text-center py-32 md:py-44">
          <p className="overline">404</p>
          <h1 className="mt-4 font-serif text-5xl md:text-7xl text-ohana-primary leading-tight">
            That page is gone.
          </h1>
          <p className="mt-5 text-lg text-ohana-text-muted max-w-lg">
            Looks like this URL got hauled away with the rest of the cleanout. Let's get you back to the homepage.
          </p>
          <div className="mt-10 flex flex-col sm:flex-row gap-3">
            <Link to="/" className="btn-primary" data-testid="not-found-home-cta">
              <Home className="mr-2 h-4 w-4" />
              Back Home
            </Link>
            <Link to="/contact" className="btn-secondary" data-testid="not-found-contact-cta">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Get a Free Quote
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
